import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AbacService } from '../../../core/services/abac.service';
import { commonConstants } from '../../constants/commonConstants';


interface FieldsDetails {
  type: string;
  formFieldLabelName: string;
  formControllName: string;
  value: any;
  disabled: boolean;
  require: boolean;
  dropdownValue?: { id: number; value: string }[];
}
@Component({
  selector: 'app-common-mdm-form',
  templateUrl: './common-mdm-form.component.html',
})
export class CommonMdmFormComponent implements OnInit {
    constructor(public readonly abacService: AbacService) { }
    @Input() fieldObject: any;
    @Input() title!: string;
    @Input() form!: FormGroup;
    @Input() isEditMode!: boolean;
    @Input() fieldId!: number;
  
    @Output() formSubmit: EventEmitter<any> = new EventEmitter<any>();
    @Output() formCancel: EventEmitter<boolean> = new EventEmitter<boolean>();
  
    backButtonLabel: string = commonConstants.backButtonLabel;
    resetButtonLabel: string = commonConstants.resetButtonLabel;
    saveButtonLabel: string = this.isEditMode ? commonConstants.updateButtonLabel : commonConstants.saveButtonLabel;
  
    ngOnInit(): void {
      this.initiateForm();
    }
    initiateForm():void{
      this.form = new FormGroup({});
      this.getFieldObjects(this.fieldObject);
    }
    getFieldObjects(fieldObject: any): void {
      fieldObject[0].formsData.forEach((field: FieldsDetails) => {
        const control = new FormControl(
          { value: this.isEditMode ? field.value : null, disabled: field.disabled },
          field.require ? Validators.required : null,
        );
        this.form.addControl(field.formControllName, control);
      });
    }
    onSave(): void {
      if (this.form.valid) {
        const obj: Record<string, any> = {};
        this.fieldObject[0].formsData.forEach((field: FieldsDetails) => {
          obj[field.formControllName] = this.form.get(field.formControllName)?.value;
        });
        this.formSubmit.emit(obj);
        this.onReset();
      } else {
        this.fieldObject[0].formsData.forEach((field: FieldsDetails) => {
          this.form.get(field.formControllName)?.markAsTouched();
        });
      }
    }
    onReset(): void {
      this.form.reset();
      this.initiateForm();
    }
    onBack(): void {
      this.formCancel.emit(false);
    }
  }